module.exports = __webpack_public_path__ + "assets/img/xx-content.921f974d.png";